export default [
    'red', 'blue', 'green', 'yellow', 'white', 'black', 'purple', 'brown', 'champion'
];